const API = "https://api.projectsmile.world";


export default API;